import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BurgerIcon = createIcon({
    viewBox: '0 0 32 32',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 7.80005H28V10.488H4V7.80005ZM4 17.112V14.488H28V17.112H4ZM4 23.8V21.112H28V23.8H4Z'
                fill='currentColor'
            />
        </>
    ),
})

BurgerIcon.displayName = 'BurgerIcon'
